import { toGalleryView } from "@ext/markdown/elements/gallery/model/gallery";

const galleryToken = {
	block: "gallery",
	getAttrs: (tok) => ({ view: toGalleryView(tok.attrs?.view), title: tok.attrs?.title ?? null }),
};

export default galleryToken;
